<template>
  <NsiCard :pageTitle="pageTitle" :apiRoute="apiRoute" :cardName="cardName" :listName="listName" />
</template>

<script>
  import NsiCard from '../components/NsiCard.vue';

  export default {
    name: 'NsiMpkBusinessStatusCard',
    components: {
      NsiCard,
    },
    data() {
      return {
        pageTitle: 'Карточка статус деловых советов',
        apiRoute: 'nsimpkbusinessstatus',
        cardName: 'NsiMpkBusinessStatusCard',
        listName: 'NsiMpkBusinessStatus',
      };
    },
    created() {},
    methods: {},
  };
</script>
